import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';

import { actions as PosActions } from '../constants/PosConstants';
import { actions as RoutingActions } from '../constants/RoutingConstants';
import { actions as UserActions } from '../constants/UserConstants';

import { events as PosEvents } from '../constants/PosConstants';

import * as _ from 'lodash';

var _state = {
    sidebarPage          : 'profile',
    showSidebar          : false,

    searchResults        : [],

    products             : [],
    productList          : [],
    productHistory       : [],
    transactionHistory   : [],
    product_details      : [],
    availableDiscounts   : false,
    appliedDiscounts     : [],
    availableFeesDonations  : [],
    calculationMethods   : [],
    labels               : [],
    autoPrintLabels      : false,
    autoPrintReceipts    : false,
    defaultLabel         : 0,
    popUpNotes           : true,
    categoryList         : [],
    masterCategoryList   : [],
    productCategories    : [],
    receiptPrinter       : false,
    labelPrinter         : false,
    availableReceiptPrinters      : [],
    availableLabelPrinters      : [],
    usePrintNode         : false,
    byStrain             : [],

    sortByLastName       : false,

    overrideDPH          : false,

    sortGLBy             : 'FullName',
    sortGLType           : 'asc',

    isSSOLoginEnabled    : false,
    currentServer        : ''
};

class PosStoreClass extends EventEmitter {

    getState() {
        return _state;
    }

    addProductDetails(item) {
        var match = false;
        for (var i=0; i<_state.product_details.length; i++) {
            if (_state.product_details[i].SerialNo === item.SerialNo) {
                _state.product_details[i] = item;
                match = true;
            }
        }

        if (!match)
            _state.product_details.push(item);

        this.emitChange();
    }

    getProductDetailsById(serial_no) {
        for (var i=0; i<_state.product_details.length; i++) {
            if (_state.product_details[i].SerialNo == serial_no)
                return _state.product_details[i];
        }

        return false;
    }

    flush() {
        _state.initialLoad          = false;
        _state.past                 = [];
        _state.availableDiscounts   = false;
        _state.appliedDiscounts     = [];
        _state.labels               = [];
        _state.calculationMethods   = [];
        // _state.appliedLoyaltyPoints = false;
    }

    emitChange(callback) {
        this.emit(PosEvents.CHANGE_EVENT, callback)
    }

    addChangeListener(callback) {
        this.on(PosEvents.CHANGE_EVENT, callback)
    }

    removeChangeListener(callback) {
        this.removeListener(PosEvents.CHANGE_EVENT, callback)
    }

    emitSearch(callback) {
        this.emit(PosEvents.SEARCH_EVENT, callback)
    }

    addSearchListener(callback) {
        this.on(PosEvents.SEARCH_EVENT, callback)
    }

    removeSearchListener(callback) {
        this.removeListener(PosEvents.SEARCH_EVENT, callback)
    }
}

const PosStore = new PosStoreClass();

PosStore.dispatchToken = AppDispatcher.register(action => {

    switch(action.actionType) {
        case PosActions.CALCULATION_METHODS_LOADED:
            _state.calculationMethods = action.data;
            PosStore.emitChange();
            break;

        case PosActions.PRODUCT_HISTORY_LOADED:
            _state.productHistory = action.data;
            PosStore.emitChange();
            break;

        case PosActions.TRANSACTION_HISTORY_LOADED:
            _state.transactionHistory = action.data;
            PosStore.emitChange();
            break;

        case PosActions.AVAIL_DISCOUNTS_LOADED:
            _state.availableDiscounts = action.data;
            PosStore.emitChange();
            break;

        case PosActions.APPLIED_DISCOUNTS_LOADED:
            _state.appliedDiscounts = action.data;
            PosStore.emitChange();
            break;
        
        case PosActions.AVAIL_FEESDONATIONS_LOADED:
            _state.availableFeesDonations = action.data;
            PosStore.emitChange();
            break;

        case PosActions.PRODUCT_DETAILS_LOADED:
            PosStore.addProductDetails(action.data);
            break;

        case PosActions.PRODUCTS_LOADED:
            _state.products = action.data;
            PosStore.emitChange();
            break;            

        case UserActions.SELECT_LOCATION:
        // case PosActions.LABELS_LOADED:
        // case PosActions.AVAILABLE_PRINTERS_LOADED:
        // case PosActions.AVAILABLE_RECEIPT_PRINTERS_LOADED:
            _state.appliedDiscounts = false;
            _state.autoPrintLabels = action.data.selectedLocation.DefaultLabelPrint;
            _state.autoPrintReceipts = action.data.selectedLocation.DefaultReceiptPrint;
            _state.availableDiscounts = false;
            _state.availableLabelPrinters = action.data.labelPrinters;
            _state.availableReceiptPrinters = action.data.receiptPrinters;
            _state.defaultLabel = action.data.selectedLocation.DefaultLabel;
            _state.labels = action.data.labels;
            _state.productHistory = [];
            _state.productCategories = false;
            _state.searchResults = [];
            _state.transactionHistory = [];
            _state.usePrintNode = action.data.usePrintNode;
            PosStore.emitChange();
            break;

        case PosActions.AUTO_PRINT_LABELS:
            _state.autoPrintLabels = action.data;
            PosStore.emitChange();
            break;

        case PosActions.AUTO_PRINT_RECEIPTS:
            _state.autoPrintReceipts = action.data;
            PosStore.emitChange();
            break;

        case PosActions.SSO_LOGIN_ENABLED:
            _state.isSSOLoginEnabled = action.data;
            PosStore.emitChange();
            break;
        case PosActions.CURRENT_SERVER:
            _state.currentServer = action.data;
            PosStore.emitChange();

        case PosActions.POP_UP_NOTES:
            _state.popUpNotes = action.data;
            PosStore.emitChange();
            break;

        case PosActions.SET_INITIAL_LOAD:
            _state.initialLoad = action.data;
            break;

        case PosActions.SET_DEFAULT_LABEL:
            _state.defaultLabel = action.data;
            PosStore.emitChange();
            break;

        case PosActions.SET_RECEIPT_PRINTER:
            var id = parseInt(action.data);
            var printer = _.find(_state.availableReceiptPrinters, p => p.PrinterId === id);
            _state.receiptPrinter = printer || { PrinterId: id };

            PosStore.emitChange();
            break;

        case PosActions.SET_LABEL_PRINTER:
            var id = parseInt(action.data);
            var printer = _.find(_state.availableLabelPrinters, p => p.PrinterId === id);
            _state.labelPrinter = printer || { PrinterId: id };
            PosStore.emitChange();
            break;

        // case PosActions.APPLY_LOYALTY_POINTS:
        //     _state.appliedLoyaltyPoints = action.data;
        //     PosStore.emitChange();
        //     break;

        case PosActions.SET_SIDEBAR_PAGE:
            _state.sidebarPage = action.data;
            PosStore.emitChange();
            break;

        case PosActions.TOGGLE_SIDEBAR:
            if (action.data === 'open' || action.data === 'close')
                _state.showSidebar = action.data === 'open' ? true : false;
            else
                _state.showSidebar = !_state.showSidebar;
            PosStore.emitChange();
            break;

        case PosActions.PRODUCT_SEARCH:
            _state.searchResults = action.data;
            _state.productList = action.data;

            var byStrain = [];
            for (var i=0; i<action.data.length; i++) {
                var match = false;
                for (var j=0; j<byStrain.length; j++) {
                    if (action.data[i].ProductCategory === byStrain[j].ProductCategory && action.data[i].Strain === byStrain[j].Strain) {
                        match = true;
                        byStrain[j].items.push(action.data[i]);
                    }
                }

                if (!match) {
                    byStrain.push({
                        ProductCategory : action.data[i].ProductCategory,
                        Strain : action.data[i].Strain,
                        items : [action.data[i]]
                    })
                }
            }

            

            _state.categoryList = _.uniqBy(action.data, 'ProductCategory').map(x => { return x.ProductCategory });
            _state.masterCategoryList = _.uniqBy(action.data, 'MasterCategory').map(x => { return x.MasterCategory; });
            _state.strainList = _.uniqBy(action.data, 'Strain').map(x => { return x.Strain; });
            _state.byStrain = byStrain;

            PosStore.emitSearch();
            break;

        case PosActions.GUEST_LIST_SORTING:
            _state.sortGLBy = action.data.sortBy;
            _state.sortGLType = action.data.sortType;
            PosStore.emitChange();
            break;

        case UserActions.REGISTER_SELECTED:
            var register = action.data;

            _state.receiptPrinter =  _.find(_state.availableReceiptPrinters, p => p.PrinterId === register.ReceiptPrinterId) || _state.receiptPrinter;
            _state.labelPrinter = _.find(_state.availableLabelPrinters, p => p.PrinterId === register.LabelPrinterId) || _state.labelPrinter;
            _state.popUpNotes = register.PopUpNotesOnEntry
            _state.autoPrintReceipts = register.AutoPrintReceipts || false;
            _state.autoPrintLabels = register.AutoPrintLabels || false;
            _state.defaultLabel = register.DefaultLabelId;

            PosStore.emitChange();
            break;

        case PosActions.OVERRIDE_DHP:
            _state.overrideDPH = action.data;
            PosStore.emitChange();
            break;
        // case RoutingActions.UPDATE_ROUTE:
        //     if (action.url === 'pos/guest-list' || action.url === 'select-location')
        //         PosStore.flush();
        //     break;
    }
});

export default PosStore;



// WEBPACK FOOTER //
// ./ui_src/app/stores/PosStore.jsx